export const colors = {
  neutral: {
    background: '#40051730',
    black: '#1E1F1F',
    gray_700: '#5A5D5D',
    gray_500: '#8D9091',
    gray_300: '#C6C8C8',
    gray_200: '#E5E6E6',
    gray_100: '#F5F5F5',
    white: '#FFFFFF'
  },

  primary: {
    primary_700: '#931710',
    primary_600: '#AE1B13',
    primary_500: '#D1281F',
    primary_100: '#F4C1BE',
    primary_50: '#FBEBEA',
  },

  secondary: {
    text: '#007980',
    original: '#00AEBD',
    trazo: '#7EDFE6',
    masa: '#E0F7F9',
  },

  contextual: {
    error:{
      text: '#74162D',
      original: '#C9264D',
      trazo: '#F7D4DD',
      masa: '#FEECF0',
    },
    success:{
      text: '#097145',
      original: '#11D07F',
      trazo: '#C7F4E1',
      masa: '#E3FDF2',
    },
    warning:{
      text: '#A2620C',
      original: '#EF9924',
      trazo: '#EFD2A9',
      masa: '#FDF2E3',
    },
    info:{
      text: '#003159',
      original: '#003159',
      trazo: '#D0E0FD',
      masa: '#D0E0FD',
    },
  },

  markers: {
    primary_700: '#0058D3',
    primary_600: '#B3CDF2',
  },

};
